export default {
    checkId: (state) => (productId) => {
        return state.ids.find((id) => id === productId) != undefined;
    },
    getIds(state) {
        return state.ids;
    },
    getLoading(state){
        return state.loading
    }
};
